export { PageLandingPageFormComponent as PageLandingPageDetail } from './component';


// WEBPACK FOOTER //
// ./src/pages/landing-page-form/index.tsx